import ReactMarkdown from "react-markdown";

import { cn } from "@/lib/utils";

const OPERATOR_SCRIPT_IMAGE_SRC = /^\/api\/manufacturing\/qc\/operator-script-images\/\d+$/;

/** Renders an operator script steps document. Pictures only load from hub operator-script images. */
export function OperatorScriptSteps({ text, className }: { text: string; className?: string }): JSX.Element | null {
  if (text.trim() === "") return null;
  return (
    <div className={cn("text-sm text-slate-800", className)}>
      <ReactMarkdown
        components={{
          p: ({ children }) => <p className="my-2 leading-6">{children}</p>,
          ul: ({ children }) => <ul className="my-2 list-disc space-y-1 pl-5">{children}</ul>,
          ol: ({ children }) => <ol className="my-2 list-decimal space-y-1 pl-5">{children}</ol>,
          strong: ({ children }) => <strong className="font-semibold text-slate-900">{children}</strong>,
          img: ({ src, alt }) =>
            typeof src === "string" && OPERATOR_SCRIPT_IMAGE_SRC.test(src) ? (
              <img src={src} alt={alt ?? ""} className="my-2 max-h-80 max-w-full rounded-md border border-slate-200" />
            ) : null,
          a: ({ children }) => <span>{children}</span>,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
